/* @flow */

import { type Endereco } from './types';
import { RETIRADA_NO_LOCAL } from './constants';

const isRetiradaNoLocal = ({ nome }: Endereco) => nome === RETIRADA_NO_LOCAL;

export default isRetiradaNoLocal;
